import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject4() {
  const data = _taggedTemplateLiteral(["\n    position: relative;\n"]);

  _templateObject4 = function () {
    return data;
  };

  return data;
}

function _templateObject3() {
  const data = _taggedTemplateLiteral(["\n    padding: 1em 2em;\n    background-color: #20242b;\n    border-radius: 3px;\n    overflow: hidden;\n    display: flex;\n    align-items: flex-end;\n    position: relative;\n    &::after,\n    &::before {\n        content: '';\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        height: 2em;\n        background-image: linear-gradient(\n            to top,\n            transparent 0%,\n            #20242b 70%,\n            #20242b 100%\n        );\n    }\n    &::before {\n        top: auto;\n        bottom: 0;\n        transform: scaleY(-1);\n    }\n"]);

  _templateObject3 = function () {
    return data;
  };

  return data;
}

function _templateObject2() {
  const data = _taggedTemplateLiteral(["\n    margin: 2em auto;\n    line-height: 1.5em;\n    color: #f0f8ff;\n"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  const data = _taggedTemplateLiteral(["\n    font-family: 'Source Code Pro', monospace;\n    font-size: 16px;\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { stripIndent } from '../../helpers/stripIndent';
import { SubSteps } from '../SubSteps';
import { appendFragments, FragmentsProvider } from './lib/appendFragments';
import { findFragments } from './lib/findFragments';
import { Tab } from './partials/Tab';
export const Code = props => {
  const fragments = findFragments(props.children);
  const code = stripIndent(props.code);
  const codeWithFragments = appendFragments(code, fragments);
  const maxHeight = props.maxHeight && normalizeSize(props.maxHeight);
  const minWidth = props.minWidth && normalizeSize(props.minWidth);
  const filename = props.filename,
        start = props.start,
        unwrap = props.unwrap,
        _props$scale = props.scale,
        scale = _props$scale === void 0 ? 1 : _props$scale;
  return React.createElement(SubSteps, {
    start: start,
    unwrap: unwrap
  }, React.createElement(FragmentsProvider.Provider, {
    value: fragments
  }, React.createElement(Wrapper, null, React.createElement(Container, {
    style: {
      fontSize: "".concat(scale, "em")
    }
  }, filename && React.createElement(Tab, {
    name: filename
  }), React.createElement(Background, {
    style: {
      maxHeight,
      minWidth
    }
  }, React.createElement(Pre, null, codeWithFragments))))));
};

const normalizeSize = size => typeof size === 'number' ? "".concat(size, "px") : size;

const Wrapper = styled.div(_templateObject());
const Container = styled.div(_templateObject2());
const Background = styled.div(_templateObject3());
const Pre = styled.pre(_templateObject4());